import classes from "./Vehicles.module.css";
import WhitePlusIcon from "../../images/deliveries/whitePlusIcon.svg";
import { useEffect } from "react";
import { ActionBtn } from "../../components/buttons/actionBtn/ActionBtn";
import { useNavigate } from "react-router-dom";
import { VehicleCard } from "../../components/vehicleCard/VehicleCard";
import { PageWrapper } from "../../components/UI/pageWrapper/PageWrapper";
import { StatusMessage } from "../../components/statusMessage/StatusMessage";
import { fetchVehicles } from "../../redux/vehicle/thunks/getVehicleThunk";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { useStatusEffect } from "../../helperFunctions/customHooks/useStatusEffect";
import { setIsDeleteVehicleShown } from "../../redux/globalFunctions/globalFnSlice";
import { resetDeleteVehicleState } from "../../redux/vehicle/deleteVehicle";
import { useDispatch, useSelector } from "react-redux";

export function Vehicles() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslations();
  const pageText = t.vehicles;
  const { status: deleteStatus } = useSelector((state) => state.deleteVehicle);
  const { status: getVehiclesStatus, vehicles } = useSelector(
    (state) => state.vehicles
  );

  useEffect(() => {
    dispatch(fetchVehicles());
  }, []);

  function handleAddNewVehicleClick() {
    navigate("/add-vehicle");
  }

  const headerButtons = [
    <ActionBtn
      onClick={handleAddNewVehicleClick}
      text={t.vehicles.addNew}
      imgSrc={WhitePlusIcon}
      height={"42px"}
    />,
  ];

  useStatusEffect({
    status: deleteStatus,
    errorMessage: pageText.errorDeleting,
    successMessage: pageText.successCreating,
    reFetch: fetchVehicles,
    resetStatus: resetDeleteVehicleState,
    onError: setIsDeleteVehicleShown,
    onSuccess: setIsDeleteVehicleShown,
  });

  return (
    <PageWrapper title={pageText.vehicles} buttons={headerButtons}>
      <div className={`${classes.content} fadeInTranslate`}>
        <section
          className={`${classes.vehicles} ${
            getVehiclesStatus === "success" ? "fadeInTranslate" : ""
          }`}
        >
          {getVehiclesStatus === "success" &&
            vehicles.length !== 0 &&
            vehicles.map((car) => (
              <VehicleCard
                key={car.v_id}
                data={car}
                index={car.v_id}
                carName={car.v_name}
                width={car.v_width}
                height={car.v_height}
                depth={car.v_depth}
                dimensions={car.v_trunk_capacity}
                driver={car.driver_fullname}
                carRegPlate={car.v_model + " " + car.v_plate_number}
                img={car.images}
              />
            ))}
          <StatusMessage
            items={vehicles}
            status={getVehiclesStatus}
            text={{
              noItemsFound: pageText.noVehiclesFound,
              errorFetching: pageText.errorFetching,
            }}
          />
        </section>
      </div>
    </PageWrapper>
  );
}
